import { Box, CircularProgress } from '@mui/material';

export const shouldShowHeadersLoadingPlaceholder = (ctx: {
  headersRequest?: unknown;
  isHeadersLoading?: boolean;
}): boolean => Boolean(ctx.headersRequest) && Boolean(ctx.isHeadersLoading);

const GeneratikTableHeadersLoadingPlaceholder = () => (
  <Box
    data-testid="table-headers-loading"
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      minHeight: 200,
    }}
  >
    <CircularProgress size={32} />
  </Box>
);

export default GeneratikTableHeadersLoadingPlaceholder;
